import { MbcAssessmentNames } from 'types/Visit/MeasurementBasedCare'
import DetailsSection from '../common/DetailsSection'
import DetailsValue from '../common/DetailsValue'
import MbcScoreCard from '../common/MbcScoreCard'
import { observer } from 'mobx-react-lite'
import MemberIndication from 'components/Dashboard/cards/Visit/common/CollapsedBlock/MeasurementBasedCare/MemberIndication'

type MbcSectionProps = {
  // TODO: improve visit type
  visit: any
}

const MbcSection = ({ visit }: MbcSectionProps) => {
  const { intakes } = visit || {}

  if (!intakes) {
    return null
  }

  return (
    <DetailsSection title="Measurement Based Care">
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-x-6 gap-y-4">
        <DetailsValue
          label={MbcAssessmentNames.GAD_7}
          value={<MbcScoreCard title={MbcAssessmentNames.GAD_7} assessment={intakes.gad7} />}
        />
        <DetailsValue
          label={MbcAssessmentNames.PHQ_9}
          value={<MbcScoreCard title={MbcAssessmentNames.PHQ_9} assessment={intakes.phq9} />}
        />
        {!!intakes?.phq9?.emergencyWarning && (
          <div className="col-span-2">
            <DetailsValue label="Member Indication" value={<MemberIndication.Banner />} />
          </div>
        )}
      </div>
    </DetailsSection>
  )
}

export default observer(MbcSection)
